// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file questionnaire/v2/questionnaire.proto (package questionnaire.v2, syntax proto3)
/* eslint-disable */

import { QuestionnaireService } from "./questionnaire_pb";

/**
 * @generated from rpc questionnaire.v2.QuestionnaireService.CreateQuestionnaire
 */
export const createQuestionnaire = QuestionnaireService.method.createQuestionnaire;

/**
 * @generated from rpc questionnaire.v2.QuestionnaireService.GetSmartEvidenceReviewSetting
 */
export const getSmartEvidenceReviewSetting = QuestionnaireService.method.getSmartEvidenceReviewSetting;

/**
 * @generated from rpc questionnaire.v2.QuestionnaireService.SetSmartEvidenceReviewSetting
 */
export const setSmartEvidenceReviewSetting = QuestionnaireService.method.setSmartEvidenceReviewSetting;

/**
 * @generated from rpc questionnaire.v2.QuestionnaireService.GetRiskQuestionnaire
 */
export const getRiskQuestionnaire = QuestionnaireService.method.getRiskQuestionnaire;

/**
 * @generated from rpc questionnaire.v2.QuestionnaireService.GetInfoQuestionnaire
 */
export const getInfoQuestionnaire = QuestionnaireService.method.getInfoQuestionnaire;

/**
 * @generated from rpc questionnaire.v2.QuestionnaireService.UpdateQuestionnaire
 */
export const updateQuestionnaire = QuestionnaireService.method.updateQuestionnaire;

/**
 * @generated from rpc questionnaire.v2.QuestionnaireService.DeleteQuestionnaire
 */
export const deleteQuestionnaire = QuestionnaireService.method.deleteQuestionnaire;

/**
 * @generated from rpc questionnaire.v2.QuestionnaireService.ListQuestionnaires
 */
export const listQuestionnaires = QuestionnaireService.method.listQuestionnaires;

/**
 * @generated from rpc questionnaire.v2.QuestionnaireService.InviteRecipients
 */
export const inviteRecipients = QuestionnaireService.method.inviteRecipients;

/**
 * @generated from rpc questionnaire.v2.QuestionnaireService.RemoveRecipients
 */
export const removeRecipients = QuestionnaireService.method.removeRecipients;

/**
 * @generated from rpc questionnaire.v2.QuestionnaireService.SubmitManualQuestionnaire
 */
export const submitManualQuestionnaire = QuestionnaireService.method.submitManualQuestionnaire;

/**
 * @generated from rpc questionnaire.v2.QuestionnaireService.SubmitRiskQuestionnaireThreadActivity
 */
export const submitRiskQuestionnaireThreadActivity = QuestionnaireService.method.submitRiskQuestionnaireThreadActivity;

/**
 * @generated from rpc questionnaire.v2.QuestionnaireService.GetPortalCommentsRoom
 */
export const getPortalCommentsRoom = QuestionnaireService.method.getPortalCommentsRoom;

/**
 * @generated from rpc questionnaire.v2.QuestionnaireService.SubmitManualQuestionnaireActivity
 */
export const submitManualQuestionnaireActivity = QuestionnaireService.method.submitManualQuestionnaireActivity;

/**
 * @generated from rpc questionnaire.v2.QuestionnaireService.DeleteManualQuestionnaireActivity
 */
export const deleteManualQuestionnaireActivity = QuestionnaireService.method.deleteManualQuestionnaireActivity;

/**
 * @generated from rpc questionnaire.v2.QuestionnaireService.UpdateManualQuestion
 */
export const updateManualQuestion = QuestionnaireService.method.updateManualQuestion;

/**
 * kept for backward compatibility with past questionnaires in Liveblocks with file questions
 *
 * @generated from rpc questionnaire.v2.QuestionnaireService.GetQuestionnaireArtifactPreviewUrl
 */
export const getQuestionnaireArtifactPreviewUrl = QuestionnaireService.method.getQuestionnaireArtifactPreviewUrl;

/**
 * @generated from rpc questionnaire.v2.QuestionnaireService.SendManualReminder
 */
export const sendManualReminder = QuestionnaireService.method.sendManualReminder;

/**
 * Consider removing this — still used in the assessment service for edge cases.
 * Must be resolved before removal.
 *
 * @generated from rpc questionnaire.v2.QuestionnaireService.FinalizeQuestionnaire
 */
export const finalizeQuestionnaire = QuestionnaireService.method.finalizeQuestionnaire;

/**
 * @generated from rpc questionnaire.v2.QuestionnaireService.GenerateQuestionnaireStatusReport
 */
export const generateQuestionnaireStatusReport = QuestionnaireService.method.generateQuestionnaireStatusReport;
